// @flow
import React from 'react';
import styled from 'styled-components';
import * as Layout from 'styles/Layout';
import Dog from 'AssetsRoot/images/homie_v3/dog.svg.react';

const Container = styled(Layout.FlexRow)`
  position: relative;
  justify-content: center;
  align-items: center;
  height: 35px;
  width: 100%;
  border-radius: 2px;
  background-color: #ffffff;
  border: 1px solid #cdcdcd;
  color: #4a4a4a;
  margin-bottom: 20px;
  cursor: pointer;
  transition: all 0.2s linear;
  &.selected {
    color: ${({ color }) => color} !important;
    border: 1px solid ${({ color }) => color};
    font-weight: bold;
  }
  &:hover {
    background-color: ${props => (props.selected ? '#ffffff' : '#f2f1f1')};
  }
  &:focus {
    background-color: #fff;
  }
`;
const OptionText = styled.span`
  min-height: 19px;
  font-size: 16px;
  line-height: 19px;
`;
const OptionIcon = styled.div`
  background-size: contain;
  height: 19px;
  width: 19px;
  margin-right: 15px;
  text-align: center;
  &.hide {
    display: none;
  }
  & svg {
    height: 100%;
    width: 100%;
  }
`;
const CheckBoxInput = styled.input`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  opacity: 0;
  cursor: pointer;
`;

const Icon = styled(Dog)`
  height: 20px;
  width: 20px;
  margin-right: 6px;
`;

const IconSelected = styled(Dog)`
  height: 20px;
  width: 20px;
  margin-right: 6px;

  path {
    stroke: ${({ color }) => color};
  }
`;

type PropsType = {
  id: string,
  name: string,
  text: string,
  Icon: any,
  IconSelected: any,
  value: boolean,
  color?: String,
  onChangeValue: (value: string, name: string) => void
};
type State = {
  Icon: any
};

export default class StatusOptionFormComponent extends React.Component<
  PropsType,
  State
> {
  static defaultProps = {
    color: '#278C7E'
  };

  constructor(props: PropsType) {
    super(props);
    this.onChangeValue = this.onChangeValue.bind(this);
  }

  onChangeValue = () => {
    this.props.onChangeValue(!this.props.value, this.props.name);
  };

  render() {
    const { color } = this.props;
    return (
      <div>
        <Container
          color={color}
          selected={this.props.value}
          className={this.props.value ? 'selected' : ''}
        >
          <OptionIcon className={!this.props.value ? '' : 'hide'}>
            <Icon />
          </OptionIcon>
          <OptionIcon className={this.props.value ? '' : 'hide'}>
            <IconSelected color={color} />
          </OptionIcon>
          <OptionText>{this.props.text}</OptionText>
          <CheckBoxInput
            name={this.props.name}
            id={this.props.id}
            type="checkbox"
            value={this.props.value}
            onChange={this.onChangeValue}
          />
        </Container>
      </div>
    );
  }
}
